<script type="text/javascript">
	import { identity } from "../Branding/Store";

	const changePageTitle = (name) => {
		let title = document.querySelector('title');
		if (title !== null) {
			title.innerHTML = name;
		}
		else {
			title = document.createElement("title");
			title.innerHTML = link;
			document.head.appendChild(title);
		}
	}
	// changePageTitle($identity.name + " Alert Portal");
	changePageTitle("Geonius");

</script>
